<template>
  <v-container fluid>
      <v-row>
          <v-col></v-col>          
      </v-row>
      <v-row>
          <v-col cols="9">
                  <ejs-schedule  :startHour="startHour" :endHour="endHour"  
                  :eventSettings="eventSettings" :timeScale="timeScale" :workHours="workHours" 
                  :popupOpen='onPopupOpen' 
                  :firstDayOfWeek="firstDayOfWeek" 
                  :eventRendered="oneventRendered"                                     
                  :currentView="currentView"
                  ref="ScheduleGroupObj">
                      <e-views>
                                <e-view option="Day"></e-view>
                                <e-view option="Week"></e-view>              
                                <e-view option="Month"></e-view>
                      </e-views>
                  </ejs-schedule>              
          </v-col>
          <v-col cols="3"></v-col>
      </v-row>
  </v-container>
</template>

<script>

import Vue from 'vue'
import { extend } from '@syncfusion/ej2-base';
import {DataManager, UrlAdaptor } from "@syncfusion/ej2-data";
import { DatePickerPlugin} from '@syncfusion/ej2-vue-calendars';
import { Day, Week, Month } from "@syncfusion/ej2-vue-schedule";
import { authHeader } from "@/helpers";
import * as helpers from "@/helpers";
Vue.use(DatePickerPlugin);
export default {
    name: 'GroupVisits',
    data(){
        return {
            startHour: "06:00",
            endHour: "22:00",
            workHours: {
                highlight: false,
                start: "06:00",
                end: "22:00"
            },
            currentView: "Week",
            firstDayOfWeek: 1,
            eventSettings: { dataSource: extend([], [], null, true) } /*dataSource: dataManger*/ ,
            slotCount: 2,
            timeScale: {
                enable: true, 
                interval: 60, 
                slotCount: 2, 
                majorSlotTemplate: null, 
                minorSlotTemplate: null
            },
            slotsNumbers: [2,4,6]
        }
    },
    methods: {        
        onPopupOpen(args) {
            args.cancel = true;
        },        
        oneventRendered: function(args) {
        },                
    },
    provide: {
      schedule: [Day, Week, Month]
    },
}
</script>

<style>

</style>